module.exports = __webpack_public_path__ + "static/media/arrow-dn.ff3c84f4.svg";